import { Navigate, Outlet } from 'react-router-dom';
import { storage } from '@/shared/utils';

export const ProtectedRoute = () => {
  const tokens = storage.getTokens();
  const isExpired = storage.isTokenExpired();

  if (!tokens || isExpired) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};
